
const CLASS_MAP = {
  "App\\Models\\Adder": "Adder",
  "App\\Models\\ConsolidatedMappingStep": "ConsolidatedMappingStep",
  "App\\Models\\ConsolidatedMappingStepValue": "ConsolidatedMappingStepValue",
  "App\\Models\\Currency": "Currency",
  "App\\Models\\DynamicAdder": "DynamicAdder",
  "App\\Models\\Factor": "Factor",
  "App\\Models\\LeadTime": "LeadTime",
  "App\\Models\\MappingStepValue": "MappingStepValue",
  "App\\Models\\Option": "Option",
  "App\\Models\\PartNumber": "PartNumber",
  "App\\Models\\Pml": "Pml",
  "App\\Models\\PriceBook": "PriceBook",
  "App\\Models\\PricedComponent": "PricedComponent",
  "App\\Models\\PricedComponentImport": "PricedComponentImport",
  "App\\Models\\PricedComponentMapping": "PricedComponentMapping",
  "App\\Models\\PricedComponentMappingStep": "PricedComponentMappingStep",
  "App\\Models\\PricingSchema": "PricingSchema",
  "App\\Models\\Series": "Series",
  "App\\Models\\Step": "Step",
  "App\\Models\\StepType": "StepType",
  "App\\Models\\PricedComponentTaxonomies\\Gender": "Gender",
  "App\\Models\\PricedComponentTaxonomies\\MilitaryClass": "MilitaryClass",
  "App\\Models\\PricedComponentTaxonomies\\MountAngle": "MountAngle",
  "App\\Models\\PricedComponentTaxonomies\\PositionsNumber": "PositionsNumber",
  "App\\Models\\PricedComponentTaxonomies\\PricedComponentTaxonomyBase":
    "PricedComponentTaxonomyBase",
  "App\\Models\\PricedComponentTaxonomies\\PriceGroup": "PriceGroup",
  "App\\Models\\PricedComponentTaxonomies\\ProductCategory": "ProductCategory",
  "App\\Models\\PricedComponentTaxonomies\\ProductGroup": "ProductGroup",
  "App\\Models\\PricedComponentTaxonomies\\Termination": "Termination",
};

import { CrudModel } from "~/plugins/Cruxtify/CrudModel";

export default {
  data() {
    return {};
  },
  props: ["logicData"],
  methods: {
    getPiece(data) {
      if (!data) {
        return "-";
      }

      if (Array.isArray(data)) {
        return {
          component: "pricing-debugger-logic-data",
          props: {
            logicData: data,
          },
        };
      }

      if (typeof data === "string" || typeof data === "number") {
        return data;
      }

      if (typeof data === "boolean") {
        return data ? "True" : "False";
      }

      if (data._class) {
        if (!data._data.id) return data._data.name;

        const modelType = CLASS_MAP[data._class];
        if (!modelType) {
          console.error(data._class, CLASS_MAP);
          return "";
        }

        const modelClass = CrudModel.getModelType(modelType);
        const modelInstance = new modelClass(data._data);

        return {
          component: "ModelLink",
          props: {
            link: modelInstance.getRouteSingle(),
            label: modelInstance.label,
          },
        };
      }

      return "-";
    },
  },
  computed: {
    pieces() {
      if (!Array.isArray(this.logicData)) {
        return [this.getPiece(this.logicData)];
      }

      return this.logicData.map((piece) => this.getPiece(piece));
    },
  },
};
